<div
  class="box-border flex w-full"
  [ngClass]="{
    'cursor-not-allowed opacity-60': ngControl.control!.disabled,
  }"
  [ngStyle]="{
    backgroundColor: isEditing() ? inputBackground() : null,
  }">
  @let hasError = ngControl.errors && ngControl.touched;
  <div class="relative w-full bg-inherit">
    <input
      [attr.data-testid]="id() | appendTestId: 'input'"
      [formControl]="ngControl.control! | toFormControl"
      (focus)="isFocused.set(true)"
      (blur)="isFocused.set(false)"
      class="border-input-ring border-input- rounded-input peer p-input w-full bg-transparent text-xl placeholder-transparent focus:ring-0"
      [ngClass]="{
        'border-input-error focus:border-input-focus': hasError,
        'border-input-ring focus:border-input-focus': !hasError,
        'pointer-events-none': ngControl.disabled,
        'pointer-events-none border-none bg-transparent': !isEditing(),
      }"
      [ngStyle]="{
        borderRadius: borderRounding(),
        borderColor: borderAndLabelColor(),
        color: corporateDesignService.fontColor(),
      }"
      [id]="id()"
      [placeholder]="label() ?? ''"
      type="text" />
    <label
      [attr.data-testid]="id() | appendTestId: 'label'"
      class="peer-placeholder-shown:text-input-text peer-focus:text-input-focus pointer-events-none absolute -top-2 right-4 left-4 w-fit max-w-[calc(100%-2rem)] cursor-text overflow-hidden bg-inherit text-sm overflow-ellipsis whitespace-nowrap transition-all peer-placeholder-shown:top-3.5 peer-placeholder-shown:text-base peer-focus:-top-2 peer-focus:text-sm"
      [ngClass]="{
        'transition-all--static -top-2! text-sm!': placeholder(),
        'text-input-error': hasError,
      }"
      [ngStyle]="{
        color: corporateDesignService.fontColor(),
      }"
      [hidden]="!isEditing()"
      [for]="id()">
      {{ formattedLabel() }}
    </label>
    @if (hasError && !errorTemplate()) {
      <aw-error-message [attr.data-testid]="id() | appendTestId: 'error'">
        <ng-content></ng-content>
      </aw-error-message>
    }
    @if (hasError && errorTemplate()) {
      <aw-error-message [attr.data-testid]="id() | appendTestId: 'error'">
        <ng-container *ngTemplateOutlet="errorTemplate()!"></ng-container>
      </aw-error-message>
    }
  </div>
</div>
